/**
 * @file Implementation of the btn component.
 */

	// -------------------------- BEGIN MODULE VARIABLES --------------------------

	// Component name
const COMPONENT_NAME = "btn";

// Element class names
const CLASSNAME = {
	ROOT: COMPONENT_NAME
};

// Element selectors
const SELECTOR = {
	ROOT: `.${ COMPONENT_NAME }`
};

// Map of DOM elements
const elements = {};

// TODO: add code here

// --------------------------- END MODULE VARIABLES ---------------------------

// -------------------------- BEGIN UTILITY FUNCTIONS -------------------------

// TODO: add code here

// --------------------------- END UTILITY FUNCTIONS --------------------------

// ----------------------------- BEGIN DOM METHODS ----------------------------

// TODO: add code here

// ------------------------------ END DOM METHODS -----------------------------

// --------------------------- BEGIN EVENT HANDLERS ---------------------------

// TODO: add code here

// ---------------------------- END EVENT HANDLERS ----------------------------

// --------------------------- BEGIN PUBLIC METHODS ---------------------------

/**
 * Initialize the btn component.
 *
 * @return {boolean} true if the component is present on the page; false
 * otherwise.
 */
function init() {
	const root = document.querySelector( SELECTOR.ROOT );
	if ( root == null ) {
		return false;
	}

	// TODO: add code here
	const toTop = document.querySelectorAll( "[data-to-top]" );

	for ( let i = 0; i < toTop.length; i++ ) {
		const element = toTop[ i ];
		element.addEventListener( "click", event => {
			event.preventDefault();
			if ( element.dataset.toTop === "true" ) {
				scrollToTop();
			}
		} );
	}

	return true;
}

const scrollToTop = () => {
	const offset = document.documentElement.scrollTop || document.body.scrollTop;
	if ( offset > 1 ) {
		window.requestAnimationFrame( scrollToTop );
		window.scrollTo( 0, offset - offset / 8 );// change 8 to manage animation speed
	}
};

// ---------------------------- END PUBLIC METHODS ----------------------------

export default {
	init
};
